import { createContextId } from '@builder.io/qwik';
import type { NavInterface } from '~/types/AppData/Layout/NavInterface';

export const NavContext = createContextId<NavInterface>('nav');
